import React, { Component, Fragment } from 'react';
import {Link, withRouter} from 'react-router-dom';

import ImportSpreadsheetModal from "./importSpreadsheetModal";
import SelectGoogleClassroomCourseModal from "./selectGoogleClassroomCourseModal"
import SpinningWheel from '../../../components/SpinningWheel'

import './add-students-flow.less'
import API from "./api";
import trackEvent from "../eventTracking";
import Alert from "../../../components/Alert";

// TO DO: eventually move some (all?) of these to the PHP .env file
// See: https://developers.google.com/classroom/reference/rest
const DISCOVERY_DOC = "https://classroom.googleapis.com/$discovery/rest?version=v1";
// eslint-disable-next-line max-len
const SCOPES = "https://www.googleapis.com/auth/classroom.courses.readonly https://www.googleapis.com/auth/classroom.rosters.readonly";
const GOOGLE_CLIENT_ID = "283427801117-gcsiu9p714dc31684r15mdoks9vupn6a.apps.googleusercontent.com";
const GOOGLE_IS = "https://accounts.google.com/gsi/client";
const GOOGLE_API = "https://apis.google.com/js/api.js";

class EnterNames extends Component {
  constructor(props) {
    super(props);

    this.client = null;

    this.state = {
      inputFields: [...this.props.studentsToAdd],
      canGoNext: false,
      importSpreadsheetModalOpened: false,
      buttonsAreSticking: true,
      selectGoogleClassroomCourseModalOpened: false,
      googleClassroomCourseMap: {},
      loading: false,
      error: {}
    }

    this.buttonsDiv = React.createRef();
    this.clickImportFromGoogleClassroom =this.clickImportFromGoogleClassroom.bind(this);

    window.scrollTo(0, 0);  // Reset page scroll
  }

  componentDidMount() {
    // Basics
    this.setState({
      canGoNext: this.hasValidName()
    })
    this[`textInput${this.state.inputFields.length - 1}`].focus();
    this.checkButtonPosition();

    // Add event listener for sticky action buttons at bottom of page
    window.addEventListener('scroll', this.handleScroll);

    // Import Google API and start initial load
    const currentFirstScriptElement = document.getElementsByTagName("script")[0];

    const scriptClient = document.createElement("script");
    scriptClient.src = GOOGLE_IS;
    scriptClient.onload = () => {this.gisInit()};
    currentFirstScriptElement.parentNode.insertBefore(scriptClient, currentFirstScriptElement);

    const scriptApi = document.createElement("script");
    scriptApi.src = GOOGLE_API;
    scriptApi.onload = () => {this.gapiLoad()};
    currentFirstScriptElement.parentNode.insertBefore(scriptApi, currentFirstScriptElement);
  }

  componentDidUpdate(_prevProps, prevState, _snapshot) {
    // After adding a new field, select it
    if (prevState.inputFields.length !== this.state.inputFields.length) {
      this[`textInput${this.state.inputFields.length - 1}`].focus();
      this.checkButtonPosition();
    }
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.handleScroll);
  }

  checkBeforeStart = () => {
    // Only enable the Google Classroom button once the identity services and api libs have been loaded.
    if (this.gapiInited && this.gisInited) {
      document.getElementById("googleClassroomDiv").classList.remove('disabled');
    }
  }

  gapiInit = () => {
    const ref = this;

    gapi.client.init({
      // NOTE: OAuth2 'scope' and 'client_id' parameters have moved to initTokenClient().
    })
      .then(function() {
        gapi.client.load(DISCOVERY_DOC);
        ref.gapiInited = true;
        ref.checkBeforeStart();
      });
  }

  gapiLoad = () => {
    gapi.load('client', this.gapiInit);
  }

  gisInit = () => {
    this.tokenClient = google.accounts.oauth2.initTokenClient({
      client_id: GOOGLE_CLIENT_ID,
      scope: SCOPES,
      callback: '',
    });

    this.gisInited = true;
    this.checkBeforeStart();
  }
  
  // Turn on/off floating buttons at bottom
  handleScroll = () => {
    this.checkButtonPosition();
  }

  // Helper Functions: General

  hasValidName = () => {
    let result = false;
    // note: javascript forEach doesn't let RETURN exist func. inside the loop. it continues thru the end of array
    // eslint-disable-next-line react/destructuring-assignment
    this.state.inputFields.forEach(value => {
      if (value.trim() !== '') {
        result = true;
      }
    });

    return result;
  }

  hasDuplicateName = () => {
    const existingPlayerNames = 
    Object.values(this.props.players).map((item) =>
      item.name
    );
    let hasDuplicate = false;
    // eslint-disable-next-line react/destructuring-assignment
    this.state.inputFields.forEach(
      (item) => {
        if(existingPlayerNames.includes(item)) {
          this.setState({
            error: {
              type: "error",
              message: `The name '${item}' already exists.`
            }
          });
          hasDuplicate = true;
        } 
        existingPlayerNames.push(item);
      }
    );
    return hasDuplicate;
  }

  handleGoNext = () => {
    if(this.hasDuplicateName()) {
      window.scrollTo(0, 0);
    } else {
      // eslint-disable-next-line react/destructuring-assignment
      this.props.moveFromNamesToSettings(this.state.inputFields);
    }
  }

  getUserInputDivs = () => {
    return (
      <Fragment>
        {/* eslint-disable-next-line react/destructuring-assignment */}
        {this.state.inputFields.map((value, i) => {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <div key={i} className={`input-row${  this.state.inputFields.length===1 ? " input-row-first-only" : ""}`}>
              <div className='input-field'>
                <input
                  className="children_names"
                  type='text'
                  value={value}
                  placeholder={`Enter ${  this.props.yourX.singular }'s first name`} // Only shows up if value is empty string
                  onKeyDown={(e) => this.handleKeyDown(e)}
                  onChange={(e) => this.handleNameChange(e, i)}
                  ref={input => {this[`textInput${i}`] = input;}}  // this is to focus
                />
              </div>
              {this.state.inputFields.length === 1 ? <Fragment/> : <div className='trash'><i className="icon-trash-light clickable-icon" onClick={() => this.handleDelete(i)}></i></div>}
            </div>
          );
        })}
      </Fragment>
    )
  }

  // Helper Functions: Manual Inputs
  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.promptedToAddNewField();
    }
  }

  handleNameChange = (e, i) => {
    // This happens on every value change of the field, typing a char & deleting char(s)
    const newValue = e.target.value;

    this.setState({
      inputFields: this.state.inputFields.map((value, j) => (i === j ? newValue : value))
    }, () => {
      this.setState({
        canGoNext: this.hasValidName()
      })
    })
  };

  promptedToAddNewField = () => {
    // Do nothing if the most bottom field is empty
    // eslint-disable-next-line react/destructuring-assignment
    if (this.state.inputFields[this.state.inputFields.length - 1] === '') {
      return;
    }

    // Show error if they have already reached capacity
    if (this.state.inputFields.length >= this.props.availableSeats) {
      this.setState({
        error: {
          type: "error",
          message: `You're using all available ${this.props.yourX.plural} accounts. Contact support@education.com to add more ${this.props.yourX.plural}.`
        }
      });
      return;
    }

    this.setState({
      // eslint-disable-next-line react/destructuring-assignment,react/no-access-state-in-setstate
      inputFields: [...this.state.inputFields, '']
    })
  }

  onDismissError = () => {
    this.setState({
      error: {}
    });
  }

  handleDelete = (i) => {
    this.setState({
      // eslint-disable-next-line react/destructuring-assignment,react/no-access-state-in-setstate
      inputFields: this.state.inputFields.filter((_, j) => (i !== j))
    }, () => {
      // If a name has been deleted, we will not be at capacity
      this.setState({
        canGoNext: this.hasValidName(),
        error: {}
      })
    })
  }

  // Helper Functions: Import from Spreadsheet
  clickImportFromSpreadsheet = () => {
    trackEvent('import names', 'started', true, 'spreadsheet');

    this.setState({
      importSpreadsheetModalOpened: true
    });

  }

  closeImportSpreadsheetModal = () => {
    this.setState({
      importSpreadsheetModalOpened: false
    });
  }

  handleUploadFromSpreadsheeet = (formData) => {
    this.setState({
      importSpreadsheetModalOpened: false,
      loading: true
    });

    API.getNamesFromSpreadsheet(formData)
      .then((resp) => {
        // Only import up to the number of available seats
        let namesList = resp.list.slice(0, this.props.availableSeats);
        let importedStudentsDifference = resp.list.length - namesList.length;
        this.setState({
            inputFields: namesList,
          }, () => {this.setState({canGoNext: this.hasValidName()})}
        );

        if (importedStudentsDifference > 0){
          this.setState({
            error: {
              type: "warning",
              message: `${this.state.inputFields.length} out of ${resp.list.length} ${this.props.yourX.plural} imported.
                  You're using all available ${this.props.yourX.plural} accounts.
                  Contact support@education.com to add more ${this.props.yourX.plural}.`
            }
          })
        }
      })
      .catch(() => {
        // Error, on modal without closing?
      })
      .finally(() => {
        this.setState({loading: false});
        window.scrollTo(0, 0);
      });
  }

  // Helper Functions: Import from Google Classroom
  closeSelectGoogleClassroomCourseModal = () => {
    this.setState({
      selectGoogleClassroomCourseModalOpened: false
    });
  }

  clickImportFromGoogleClassroom = () => {
    trackEvent('import names', 'started', true, 'google classroom');

    this.tokenClient.callback = (resp) => {

      // Get granted scopes.
      if (resp.error !== undefined) {
        // If user go through the google classroom access granting process without granting any new access, we will
        // get resp.error = "access_denied" and an undefined resp.scope. Under this situation, since there's no reliable
        // way to grab previously granted scope(s) without a valid response, we are using generic language to inform
        // user that the class roster cannot be imported from Google Classroom due to insufficient access being granted.
        let errorMsg = null;
        if (resp.error === 'access_denied') {
          errorMsg = 'Unable to import student names. It looks like we don’t have the necessary permissions to access your Google Classroom.';
        }
        else {
          errorMsg = 'Something unexpected happened and we were unable to import student names from your Google Classroom, please try again.';
        }
        this.setState({
          error: {
            type: "warning",
            message: errorMsg
          }
        });
        throw(resp);
      }
      else {
        // Check the google oauth granular access control. Only allow name import when both courses and rosters
        // readonly accesses have been granted,
        const courseAccess = resp.scope.includes('https://www.googleapis.com/auth/classroom.courses.readonly');
        const rosterAccess = resp.scope.includes('https://www.googleapis.com/auth/classroom.rosters.readonly');

        // Otherwise, inform user that the import attempt is aborted due to the insufficient access.
        if (!courseAccess || !rosterAccess) {
          let missingAccessItems;
          if (courseAccess && !rosterAccess) {
            missingAccessItems = 'class rosters';
          }
          else if (!courseAccess && rosterAccess) {
            missingAccessItems = 'classes';
          }
          else {
            missingAccessItems = 'class rosters and classes';
          }

          this.setState({
            error: {
              type: "warning",
              message: `Unable to import student names from Google classroom. Missing read-only access to Google Classroom ${missingAccessItems}.`
            }
          })

          return;
        }
        else {
          // Set error to empty to clear the alert message on screen if full access has been granted.
          this.setState({
            error: {}
          })
        }
      }

      const coursesList = [];
      // Maximum number of items to return. Zero means no maximum.
      const params = {
        pageSize: 0
      };

      (async function loop() {
        // eslint-disable-next-line no-constant-condition
        while (true) {
          // eslint-disable-next-line no-await-in-loop
          const response = await gapi.client.classroom.courses.list(params);
          const {result} = response;

          if (result.courses) {
            result.courses.forEach((course => {
              coursesList.push(course);
            }))
          }

          if (!result.nextPageToken) {
            break;
          }

          params.pageToken = result.nextPageToken;
        }
      })()
        .then(() => {
          // Modal shows up, then it will call uploadStudentsFromGoogleClassroom
          const courseMap = {};
          coursesList.forEach((course => {
            courseMap[course.id] = course.name;
          }));

          this.setState({
            loading: false,
            selectGoogleClassroomCourseModalOpened: true,
            googleClassroomCourseMap: courseMap
          })
        })
    }

    // Conditionally ask users to select the Google Account they'd like to use,
    // and explicitly obtain their consent to fetch their Google Classroom info..
    // NOTE: To request an access token a user gesture is necessary.
    if (gapi.client.getToken() === null) {
      // Prompt the user to select an Google Account and asked for consent to share their data
      // when establishing a new session.
      this.tokenClient.requestAccessToken({prompt: 'consent'});
    }
    else {
      // Skip display of account chooser and consent dialog for an existing session.
      this.tokenClient.requestAccessToken({prompt: ''});
    }
  }

  uploadStudentsFromGoogleClassroom = (courseId) => {
    this.setState({
      selectGoogleClassroomCourseModalOpened: false,
      loading: true
    });

    // Will populate namesList to update the state with
    let namesList = [];
    const params = {
      courseId,
      pageSize: 0  // Maximum number of items to return. Zero means no maximum. 30 students per page is the current max.
    };

    // Promise in loop, each step waits for the previous step to finish
    (async function loop() {
      while (true) {
        // eslint-disable-next-line no-await-in-loop
        const response = await gapi.client.classroom.courses.students.list(params);
        const {result} = response;

        if (result.students) {
          result.students.forEach((student => {
            namesList.push(student.profile.name.fullName);
          }))
        }

        if (!result.nextPageToken) {
          break;
        }

        params.pageToken = result.nextPageToken;
      }
    })()
      .then(() => {
        if (namesList.length > 0) {
          // Only import up to the number of available seats
          let originalListSize = namesList.length;
          namesList = namesList.slice(0, this.props.availableSeats);
          let importedStudentsDifference = originalListSize - namesList.length;
          this.setState({
            inputFields: namesList,
          }, () => {
            this.setState({
              canGoNext: this.hasValidName(),
              loading: false
            })
          })

          if (importedStudentsDifference > 0){
            this.setState({
              error: {
                type: "warning",
                message: `${this.state.inputFields.length} out of ${originalListSize} ${this.props.yourX.plural} imported.
                  You're using all available ${this.props.yourX.plural} accounts.
                  Contact support@education.com to add more ${this.props.yourX.plural}.`
              }
            })
          }

          window.scrollTo(0, 0);
        }
        else {
          this.setState({
            canGoNext: this.hasValidName(),
            loading: false
          });

          window.scrollTo(0, 0);
        }
      })
      .catch(() => {
        window.scrollTo(0, 0);
        this.setState({loading: false})
      })
  }

  checkButtonPosition() {
    // buttonDivInfo.button is the # of pixels from top of the page to the bottom oof the buttons div
    // window.innerHeight is the # of visible pixels for the height of the browser. this changes if browser is resized
    // As soon as the bottom of the buttons div becomes invisible, turn on the sticky. otherwise, off.
    const buttonDivInfo = this.buttonsDiv.current.getBoundingClientRect();
    this.setState({
      buttonsAreSticking: buttonDivInfo.bottom >= window.innerHeight
    });
  }

  render() {
    return (
      <Fragment>
        <div className="main-container enter-names">
          {this.state.error && this.state.error.message &&
            <Alert color={this.state.error.type} dismissable={true} onClose={this.onDismissError}>
              {this.state.error.message}
            </Alert>
          }
          {/* 1. Manual entering */}
          <div className="instruction">
            <p>Enter a name per field. Hit Enter to add another {this.props.yourX.singular}.</p>
          </div>
          <div className='form'>
            {this.getUserInputDivs()}
          </div>
          <div>
            <a
              className={`btn btn-secondary${  this.state.inputFields[this.state.inputFields.length - 1].trim() === '' ? ' disabled' : ''}`}
              onClick={() => this.promptedToAddNewField()}
            >
              Add another name
            </a>
          </div>

          {/* 2. divider */}
          <div className='or-line'>
            <h4><span>OR</span></h4>
          </div>

          {/* 3. Import from other sources */}
          <div className="import-names-container">
            <div className="clear-button-container">
              <div className='form'>
                <a onClick={()=>this.clickImportFromSpreadsheet()}>
                  <label className='clear-button'>
                    <div className="border" />
                    <div className="text">
                      <div className="middle">
                        <img src="/themes/sky/i/progress-tracker/img-spreadsheet-small.png"/>
                        <div className="clear-button-text">Import from spreadsheet</div>
                      </div>
                    </div>
                  </label>
                </a>
              </div>
            </div>

            <div className="clear-button-container disabled" id="googleClassroomDiv">
              <div className='form'>
                <a onClick={()=>this.clickImportFromGoogleClassroom()}>
                  <label className='clear-button'>
                    <div className="border" />
                    <div className="text">
                      <div className="middle">
                        <img src="/themes/sky/i/progress-tracker/img-google-classroom.png"/>
                        <div className="clear-button-text">Import from Google Classroom</div>
                      </div>
                    </div>
                  </label>
                </a>
              </div>
            </div>
          </div>

          {/* 4. Actions */}
          {/* // This one is a part of the page. No turning on/off */}
          <div ref={this.buttonsDiv} className="bottom-buttons">
            <div className="button-container"><Link className="btn btn-secondary" to="/my/students/">Cancel</Link></div>
            <div className="button-container"><button
              className={`btn btn-primary btn-next${  this.state.canGoNext ? "" : " disabled"}`}
              onClick={()=>this.handleGoNext()}
              data-cy="next-step-button"
            >
              Next step
            </button></div>
          </div>

          {/* // This one floats at bottom of page. Turning on/off */}
          <div className={`bottom-buttons sticky ${  this.state.buttonsAreSticking ? "visible" : ""}`}>
            <div className="bottom-buttons-container">
              <div className="button-container"><Link className="btn btn-secondary" to="/my/students/">Cancel</Link></div>
              <div className="button-container"><button
                className={`btn btn-primary btn-next${  this.state.canGoNext ? "" : " disabled"}`}
                onClick={()=>this.handleGoNext()}
              >
                Next step
              </button></div>
            </div>
          </div>
        </div>

        <ImportSpreadsheetModal
          yourX={this.props.yourX}
          open={this.state.importSpreadsheetModalOpened}
          closeImportSpreadsheetModal={this.closeImportSpreadsheetModal}
          handleUploadFromSpreadsheeet={this.handleUploadFromSpreadsheeet}
        />

        <SelectGoogleClassroomCourseModal
          open={this.state.selectGoogleClassroomCourseModalOpened}
          closeSelectGoogleClassroomCourseModal={this.closeSelectGoogleClassroomCourseModal}
          handleSubmit={this.uploadStudentsFromGoogleClassroom}
          courseMap={this.state.googleClassroomCourseMap}
        />

        {this.state.loading ? <SpinningWheel fullScreen={true}/> : <Fragment />}
      </Fragment>
    )
  }
}

export default withRouter(EnterNames);
